<script lang="ts">
	import type { IconProps } from "../vite/Icon";
	import LoadingIndicator from "./components/utility/LoadingIndicator.svelte";
	import { fadeReduced } from "./utils/svelte/fadeReduced";

	const attrs: IconProps = $props();
</script>

<div
	class="fixed inset-0 z-100 grid place-items-center bg-black/5 backdrop-blur-xs"
	transition:fadeReduced={{ duration: 300, delay: 150 }}
>
	<div class="flex flex-col items-center gap-4">
		<LoadingIndicator
			doglioLogo
			{...attrs}
			class={["text-secondary-400 aspect-square size-[5dvw] not-motion-reduce:animate-spin", attrs.class]}
			forceRender
		/>
	</div>
</div>
